
import React, { useState, useEffect } from "react";
import { Box, keyframes } from "@mui/material";
import "../VivaExam/VivaExam.css";


export const DummyExamName = () => {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", borderBottom: "1px solid var(--border, #ccc)", pb: 1, mb: 2 }}>

            {/* Section with animated background */}
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    p: 2,
                    borderRadius: 2,
                    position: "relative",
                    overflow: "hidden"
                }}
            >
              
                <Box sx={{ textAlign: "center" }}>
                    <h1 className="Text1 tour-exam-name" >Python Exam</h1>
                </Box>
               
            </Box>
        </Box>

    )
}
